import { Plus, X } from "lucide-react";
import { useApp } from "@/lib/i18n";
import { AutoText, IconBtn } from "./Field";

const GROUPS = [["hadir", "HADIR"], ["turut_hadir", "TURUT HADIR"], ["tidak_hadir", "TIDAK HADIR"], ["urus_setia", "URUS SETIA"]];

export const AttendanceEditor = ({ attendance = {}, onChange, canWrite }) => {
  const { L } = useApp();
  const set = (k, list) => onChange({ ...attendance, [k]: list });
  return (
    <div className="space-y-5" data-testid="official-attendance">
      {GROUPS.map(([k, label]) => {
        const list = attendance[k] || [];
        if (!canWrite && !list.length) return null;
        return (
          <div key={k} data-testid={`attendance-${k}`}>
            <p className="font-bold">{label}{k === "urus_setia" ? " :" : ""}</p>
            {list.map((p, i) => (
              <div key={i} className="group mt-1 grid grid-cols-[2rem_1fr_1fr_1.75rem] items-start gap-2">
                <span className="pt-1">{i + 1}.</span>
                <AutoText value={p.name} disabled={!canWrite} onChange={(v) => set(k, list.map((x, j) => (j === i ? { ...x, name: v } : x)))} testId={`attendance-${k}-name-${i}`} placeholder={L("Nama", "Name")} />
                <AutoText value={p.position} disabled={!canWrite} onChange={(v) => set(k, list.map((x, j) => (j === i ? { ...x, position: v } : x)))} testId={`attendance-${k}-position-${i}`} placeholder={L("Jawatan, Agensi", "Position, Agency")} />
                {canWrite && <IconBtn onClick={() => set(k, list.filter((_, j) => j !== i))} label={L("Buang", "Remove")} testId={`attendance-${k}-remove-${i}`}><X size={14} /></IconBtn>}
              </div>
            ))}
            {canWrite && <button onClick={() => set(k, [...list, { name: "", position: "" }])} className="mt-1 flex items-center gap-1 text-xs font-semibold text-violet-700 hover:underline" data-testid={`attendance-${k}-add`}><Plus size={12} /> {L("Tambah nama", "Add name")}</button>}
          </div>
        );
      })}
    </div>
  );
};
